"use strict";
const PUBLIC_PATHS = Object.freeze(["/", "/astroanamnesis", "/crear-carta", "/donaciones", "/suscripcion", "/informes", "/sesiones", "/tienda"]);
const valid = language => language === "en" || language === "es";
function publicRoute(pathname) {
  const english = pathname === "/en" || pathname.startsWith("/en/");
  const path = (english ? pathname.slice(3) : pathname).replace(/\/+$/, "") || "/";
  return PUBLIC_PATHS.includes(path) ? { path, language: english ? "en" : "es" } : null;
}
function publicPath(path, language) {
  const route = publicRoute(path);
  return route ? (language === "en" ? "/en" + (route.path === "/" ? "/" : route.path) : route.path) : path;
}
module.exports = { PUBLIC_PATHS, valid, publicRoute, publicPath };
